<template>
  <div
    class="flex flex-col justify-center items-center bg-black h-screen bg-opacity-70"
  >
    <div class="bg-white w-2/3 rounded-md p-4">
      <div class="text-left mb-4">
        <p>New Version (v{{ update?.latestVersion }}) available.</p>
        <p class="mb-2 text-xs">{{ update?.updateText }}</p>
        <p v-if="update?.newFeatures" class="text-xs">What's new:</p>
        <ul class="list-disc list-inside text-xxs">
          <li v-for="item in update?.newFeatures" :key="item">{{ item }}</li>
        </ul>
        <p v-if="!update?.forceUpdate" class="text-xxs mt-1">
          To continue using the old version,
          <button class="text-bnb-brown" @click="$emit('useOldVersion')">
            click here
          </button>
        </p>
      </div>
      <div class="flex justify-evenly">
        <button
          @click="updateApp"
          class="text-white text-lg px-2 font-bold py-0.5 animate-bounce rounded-md bg-bnb-mustard"
        >
          UPDATE
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Device } from "@capacitor/device";
export default {
  data() {
    return {
      update: this.$store.state.appDetails.update,
    };
  },
  methods: {
    updateApp() {
      Device.getInfo().then((infoObject) => {
        var platform = infoObject.platform;
        if (platform == "android") {
          location.href = this.update?.androidLink;
        } else if (platform == "ios") {
          location.href = this.update?.iosLink;
        }
      });
    },
  },
};
</script>
